import React, { useState } from 'react';
import { AlertDialog } from '../dialogs/dialog';
import { ModalOfferReject } from '../modals/modalOfferReject';

export const Danger = (props) => {

  const [doc, setDoc] = useState(props.doc);
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  }

  return (
    <div>

      {
        openDialog ? <ModalOfferReject doc={doc} isOpen={openDialog}></ModalOfferReject> :
          <div></div>
      }

      <button
        onClick={handleOpenDialog}
        type='button'
        className="w-full text-xl flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm font-medium text-red bg-red bg-opacity-10 transition duration-300 hover:bg-red  hover:text-white focus:outline-none"
      >
        {props.text}
      </button>
    </div>
  );
};